import { render, staticRenderFns } from "./recUserRole.vue?vue&type=template&id=4ae9cefb&"
import script from "./recUserRole.vue?vue&type=script&lang=js&"
export * from "./recUserRole.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports